import { useState } from "react";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { api } from "../lib/api";
import { useTheme } from "../context/ThemeContext";
import { toast } from "sonner";

export default function Contact() {
  const t = useTheme();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", { location: t.location, ...form }); toast.success("Message sent."); setForm({ name: "", email: "", phone: "", message: "" }); }
    catch { toast.error("Could not send"); }
  };
  const info = { addr: "737 SW 109th Ave STE 106, Miami, FL 33174", phone: "+1 (786) 609-6198", email: "axtremehairstyle@gmail.com", hrs: "Mon–Sat: 10:00–20:00" };
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16" data-testid="contact-page">
      <div className="text-[11px] tracking-[0.4em] uppercase opacity-70" style={{ color: t.primary }}>Contact</div>
      <h1 className="mt-3 text-5xl sm:text-6xl" style={{ color: t.text }}>Visit the {t.name} studio</h1>

      <div className="mt-12 grid md:grid-cols-2 gap-12">
        <div>
          <ul className="space-y-5">
            <li className="flex gap-4"><MapPin className="w-5 h-5 mt-1" style={{ color: t.primary }} /><span>{info.addr}</span></li>
            <li className="flex gap-4"><Phone className="w-5 h-5 mt-1" style={{ color: t.primary }} /><span>{info.phone}</span></li>
            <li className="flex gap-4"><Mail className="w-5 h-5 mt-1" style={{ color: t.primary }} /><span>{info.email}</span></li>
            <li className="flex gap-4"><Clock className="w-5 h-5 mt-1" style={{ color: t.primary }} /><span>{info.hrs}</span></li>
          </ul>
          <div className="mt-8 aspect-video w-full" style={{ background: t.bgBase, border: `1px solid ${t.location === 'ocala' ? '#B5A99A66' : '#E5E5E5'}` }}>
            <iframe title="map" src={`https://www.google.com/maps?q=${encodeURIComponent(info.addr)}&output=embed`} className="w-full h-full" />
          </div>
        </div>
        <form onSubmit={submit} className={`p-8 bg-white border ${t.accentBorder} grid gap-5`} style={{ borderBottom: t.location === 'miami' ? `3px solid ${t.primary}` : undefined }} data-testid="contact-form">
          <h2 className="text-3xl" style={{ color: t.text }}>Send a message</h2>
          {[['name','Name'],['email','Email'],['phone','Phone (optional)']].map(([k,l]) => (
            <input key={k} type={k==='email'?'email':'text'} placeholder={l} value={form[k]} onChange={e => setForm({ ...form, [k]: e.target.value })} required={k!=='phone'} className={`p-3 border ${t.accentBorder} bg-transparent`} data-testid={`contact-${k}`} />
          ))}
          <textarea rows={5} placeholder="Message" required value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} className={`p-3 border ${t.accentBorder} bg-transparent`} data-testid="contact-message" />
          <button type="submit" className={`px-6 py-3 text-xs tracking-[0.3em] uppercase ${t.btnPrimary}`} data-testid="contact-submit">Send Message</button>
        </form>
      </div>
    </div>
  );
}
